import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Chevron, the muted disclosure glyph.
 *
 * CSS selector: `mobile/atoms.css` `.ds-chevron`, which owns the muted colour
 * and the `stroke: currentColor; stroke-width: 2; fill: none` conventions for
 * every row, accordion and drill-in in the mobile track.
 *
 * Doctrine: chevrons and back arrows take the heavier end of the stroke range,
 * 2 to 2.25, while list icons take 1.7 to 1.8. The stroke here comes from the
 * CSS rather than an attribute so all four directions stay identical.
 *
 * Direction swaps the path rather than applying a rotation, so there is no
 * inline transform and the glyph stays crisp on the 24 grid at every angle.
 */
const CHEVRON_PATH = {
  right: 'M9 6l6 6-6 6',
  left: 'M15 6l-6 6 6 6',
  down: 'M6 9l6 6 6-6',
  up: 'M6 15l6-6 6 6',
};

export const Chevron = React.forwardRef(function Chevron(
  { className, direction = 'right', width = 20, height = 20, ...rest },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={cn('ds-chevron', className)}
      {...rest}
    >
      <path d={CHEVRON_PATH[direction]} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
});

export default Chevron;
